const DEMO_PURI_PREFIX = "/demo/puri";

const toBool = (value, fallback = false) => {
  if (value === "" || value == null) return fallback;
  if (typeof value === "boolean") return value;
  const normalized = String(value).trim().toLowerCase();
  if (["true", "1", "yes", "on"].includes(normalized)) return true;
  if (["false", "0", "no", "off"].includes(normalized)) return false;
  return fallback;
};

const normalizePathname = (value = "") => {
  const raw = String(value || "").trim();
  if (!raw) return "/";
  const withoutQuery = raw.split("?")[0].split("#")[0] || "/";
  const normalized = withoutQuery.startsWith("/") ? withoutQuery : `/${withoutQuery}`;
  return normalized.length > 1 ? normalized.replace(/\/+$/, "") : normalized;
};

export const isPuriDemoPath = (pathname = "") => {
  const normalized = normalizePathname(pathname);
  return normalized === DEMO_PURI_PREFIX || normalized.startsWith(`${DEMO_PURI_PREFIX}/`);
};

export const getDemoPuriHomePath = () => DEMO_PURI_PREFIX;

export const isPuriDemoEnabled = () => toBool(process.env.REACT_APP_ENABLE_PURI_DEMO, false);
